import React from "react";
import { Outlet } from "react-router-dom";

import CheckSimFooter from "./CheckSimFooter";
import ChecksimHeader from "./ChecksimHeader";

const CheckSimLayout = () => {
  return (
    <div>
      <ChecksimHeader />
      <Outlet />
      <CheckSimFooter />
    </div>
  );
};

export default CheckSimLayout;
